import React, { useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { useParams } from 'react-router-dom';
import DDWAInitiateProposalPageStore, {
  DDWAInitiateProposalPageStoreContext,
  useDDWAInitiateProposalPageStore,
} from 'store/pages/initiate-quote/ddwa/pageStore';
import DDWAInitiateProposalForm from 'components/initiate-quote/DDWA';
import InitiateProposalPageLayout from 'components/common/initiate-proposal/InitiateProposalPageLayout';
import QuoteExperienceStep from 'components/common/initiate-proposal/QuoteExperienceStep';
import FavoriteQuoteStep from 'components/common/initiate-proposal/FavoriteQuoteStep';

const PageContent: React.FC = observer(() => {
  const {
    initiateQuoteFlowDelegate,
    bulletTabsDelegate,
    basicInfoStepController,
    proposalExperienceStepController,
    favoriteProposalStepController,
    proposalExperience,
    getInitialData,
  } = useDDWAInitiateProposalPageStore();

  useEffect(() => {
    void getInitialData();
  }, []);

  return (
    <InitiateProposalPageLayout
      initiateQuoteFlowDelegate={initiateQuoteFlowDelegate}
      bulletTabsDelegate={bulletTabsDelegate}
      tabs={[
        <DDWAInitiateProposalForm key="0" basicInfoStepController={basicInfoStepController} />,
        <QuoteExperienceStep
          key="1"
          formController={proposalExperienceStepController.form}
          experiences={proposalExperienceStepController.experiences}
          experienceDisabledReasons={proposalExperienceStepController.experienceDisabledReasons}
          experienceAccessLimitations={proposalExperienceStepController.experienceAccessLimitations}
          renewalActionsDelegate={proposalExperienceStepController.renewalActionsDelegate}
        />,
        proposalExperience === 'FAVORITE' && (
          <FavoriteQuoteStep key="2" favoriteProposalStepController={favoriteProposalStepController} />
        ),
      ].filter(Boolean)}
    />
  );
});

const DDWAInitiateProposalPage: React.FC = () => {
  const { groupId } = useParams<{ groupId: string }>();

  const pageStore = useMemo(() => new DDWAInitiateProposalPageStore({ groupId }), [groupId]);

  return (
    <DDWAInitiateProposalPageStoreContext.Provider value={pageStore}>
      <PageContent />
    </DDWAInitiateProposalPageStoreContext.Provider>
  );
};

export default DDWAInitiateProposalPage;
